import React from "react";
import { Grid, IconButton, Typography } from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import * as dateFns from "date-fns";

const CalendarHeader = ({ currentMonth, onPrevMonth, onNextMonth }) => {
  // ✅ Ensure currentMonth is valid
  const safeCurrentMonth = currentMonth || dateFns.format(new Date(), "MM-yyyy");

  // ✅ Convert string to Date safely
  const currentMonthDate = dateFns.parse(safeCurrentMonth, "MM-yyyy", new Date());

  // ✅ Check if currentMonthDate is a valid Date
  const formattedMonth = dateFns.isValid(currentMonthDate)
    ? dateFns.format(currentMonthDate, "MMMM yyyy")
    : "Invalid Date";

  return (
    <Grid container alignItems="center" justifyContent="space-between">
      <Grid item>
        <IconButton onClick={onPrevMonth} aria-label="Previous month">
          <ArrowBackIosIcon />
        </IconButton>
      </Grid>
      <Grid item>
        <Typography variant="h6" color="primary">
          {formattedMonth}
        </Typography>
      </Grid>
      <Grid item>
        <IconButton onClick={onNextMonth} aria-label="Next month">
          <ArrowForwardIosIcon />
        </IconButton>
      </Grid>
    </Grid>
  );
};

export default CalendarHeader;
